<template>
    <default-item class="menu--item-wv_steak_house_cocktail" :item="item"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for WV Steak House food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.2
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - <WvSteakHouseFoodItem> copied to <WvSteakHouseCocktailItem>.
 *
 *    2024-07-19 (1.0.1) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <wv-steak-house-cocktail-item>.
 *
 *    2025-04-08 (1.0.2) (jhoward)
 *      - Remove "visual_" prefix from class names in <WVSteakHouseCocktailItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'WVSteakHouseCocktailItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--item-wv_steak_house_cocktail + .menu--item-wv_steak_house_cocktail {
  margin-top: 2em;
}

.menu--item-wv_steak_house_cocktail:deep(.menu--tag) {
  right: 0;
  width: 3em;
  height: 4em;
  line-height: 4em;
}
</style>